import React from 'react';
import { useIPTV } from '../../context/IPTVContext';
import { LivePlayer } from './LivePlayer';
import { VodPlayer } from './VodPlayer';

/**
 * Universal Video Player Orchestrator
 * Delegated to dedicated, isolated players:
 * - Live TV & Live 4K: LivePlayer
 * - Movies, 4K Movies & Series: VodPlayer
 */
export const VideoPlayer: React.FC = () => {
  const { currentChannel, currentMovie, currentSeries, currentEpisode } = useIPTV();

  if (currentChannel) {
    return <LivePlayer />;
  }

  if (currentMovie || (currentSeries && currentEpisode)) {
    return <VodPlayer />;
  }

  return null;
};
